import { useQuery } from "@tanstack/react-query";

import { ThreediModel } from "@nens/threedi/openapi-client";

import { MANAGEMENT_SCREEN_URL, getV3Api, getV3BetaApi } from "../apiConfiguration";
import { Breach } from "../types/assets";

// Returns current Rana HCC framework version on the backend, or null
// if the request is not finished yet.
export function useThreediVersion(): string | null {
  const api = getV3BetaApi();
  const statusResponse = useQuery({
    queryKey: ["statusCurrentVersion"],
    queryFn: () => api.statusCurrentVersion(),
  });

  if (statusResponse.isSuccess) {
    return statusResponse.data?.threediVersion || null;
  } else {
    return null;
  }
}

export function useErrorIfModelNotUpToDate(message: string, model: ThreediModel | null) {
  const version = useThreediVersion();

  // If model is up to date, or we cannot check whether it is, send
  // message back as is.
  if (
    version === null ||
    model === null ||
    !model.threediVersion ||
    version === model.threediVersion
  )
    return message;

  // If we can link to it, do so. In that case, return a JSX element!
  if (model.schematisationId && model.revisionId) {
    const modelUrl = `${MANAGEMENT_SCREEN_URL}/schematisations/${model.schematisationId}/${model.revisionId}`;

    return (
      <span>
        {message + " The model is out of date, try re-generating it at "}
        <a href={modelUrl} target="_blank" rel="noreferrer">
          {modelUrl}
        </a>
        .
      </span>
    );
  } else {
    return `${message} The model is out of date, try re-generating it.`;
  }
}

export function useModelPotentialBreach(breach: Breach, threediModelId: number) {
  const api = getV3Api();
  const contentPk = breach.properties.content_pk;

  const response = useQuery({
    queryKey: ["threedimodelsPotentialbreachesList", threediModelId, contentPk],
    queryFn: () =>
      api.threedimodelsPotentialbreachesList({
        threedimodelPk: threediModelId,
        connectedPntId: contentPk,
      }),
  });

  if (response.isSuccess) {
    const potentialBreaches = response.data.results;
    if (potentialBreaches.length > 0) {
      return potentialBreaches[0];
    } else {
      return null;
    }
  } else {
    return null;
  }
}
